/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  // Dynamic Free Shipping Threshold Logic
  class DynamicFreeShipping {
    constructor() {
      // Load configuration from theme settings
      this.loadConfiguration();

      this.init();
    }

    loadConfiguration() {
      // Get settings from theme or use defaults
      const shippingSettings = window.themeSettings?.shipping || {};
      const configJson = shippingSettings.configJson || null;
      const countrySettings = shippingSettings.countrySettings || {};
      const defaults = shippingSettings.defaults || {
        threshold: 80,
        shipping_cost: 15,
        delivery_time: '2-5'
      };

      // Initialize empty objects
      this.countryThresholds = {};
      this.countryShippingCosts = {};
      this.countryDeliveryTimes = {};

      // Load from simple country settings (user-friendly fields)
      // These fields always have default values, so we always use them
      if (countrySettings.DE) {
        const de = countrySettings.DE;
        this.countryThresholds['DE'] = de.threshold || defaults.threshold;
        this.countryShippingCosts['DE'] = de.shipping_cost || defaults.shipping_cost;
        this.countryDeliveryTimes['DE'] = de.delivery_time || defaults.delivery_time;
      }

      if (countrySettings.CENTRAL_EU) {
        const group = countrySettings.CENTRAL_EU;
        const countries = group.countries || ['AT', 'CH', 'CZ', 'SK', 'HU', 'PL', 'SI'];
        countries.forEach(code => {
          this.countryThresholds[code] = group.threshold || defaults.threshold;
          this.countryShippingCosts[code] = group.shipping_cost || defaults.shipping_cost;
          this.countryDeliveryTimes[code] = group.delivery_time || defaults.delivery_time;
        });
      }

      if (countrySettings.BENELUX_WEST) {
        const group = countrySettings.BENELUX_WEST;
        const countries = group.countries || ['BE', 'LU', 'NL', 'FR', 'MC', 'GB', 'IE', 'LI'];
        countries.forEach(code => {
          this.countryThresholds[code] = group.threshold || defaults.threshold;
          this.countryShippingCosts[code] = group.shipping_cost || defaults.shipping_cost;
          this.countryDeliveryTimes[code] = group.delivery_time || defaults.delivery_time;
        });
      }

      if (countrySettings.NORDIC) {
        const group = countrySettings.NORDIC;
        const countries = group.countries || ['DK', 'SE', 'NO', 'FI', 'EE', 'LV', 'LT', 'IS'];
        countries.forEach(code => {
          this.countryThresholds[code] = group.threshold || defaults.threshold;
          this.countryShippingCosts[code] = group.shipping_cost || defaults.shipping_cost;
          this.countryDeliveryTimes[code] = group.delivery_time || defaults.delivery_time;
        });
      }

      if (countrySettings.SOUTHERN_EU) {
        const group = countrySettings.SOUTHERN_EU;
        const countries = group.countries || ['IT', 'ES', 'PT', 'GR'];
        countries.forEach(code => {
          this.countryThresholds[code] = group.threshold || defaults.threshold;
          this.countryShippingCosts[code] = group.shipping_cost || defaults.shipping_cost;
          this.countryDeliveryTimes[code] = group.delivery_time || defaults.delivery_time;
        });
      }

      if (countrySettings.EASTERN_EU) {
        const group = countrySettings.EASTERN_EU;
        const countries = group.countries || ['RO', 'BG', 'HR', 'BA', 'RS', 'UA'];
        countries.forEach(code => {
          this.countryThresholds[code] = group.threshold || defaults.threshold;
          this.countryShippingCosts[code] = group.shipping_cost || defaults.shipping_cost;
          this.countryDeliveryTimes[code] = group.delivery_time || defaults.delivery_time;
        });
      }

      // Then, parse JSON configuration if available (for advanced users - can override simple settings)
      if (configJson) {
        try {
          // If configJson is a string, parse it; otherwise use as-is
          const parsedConfig = typeof configJson === 'string' ? JSON.parse(configJson) : configJson;

          // Only process if it's an object
          if (parsedConfig && typeof parsedConfig === 'object') {
            // Extract values from configuration (this will override simple settings)
            Object.keys(parsedConfig).forEach(countryCode => {
              const countryData = parsedConfig[countryCode];
              if (countryData && typeof countryData === 'object') {
                const code = countryCode.toUpperCase();

                this.countryThresholds[code] = countryData.threshold || defaults.threshold;
                this.countryShippingCosts[code] = countryData.shipping_cost || defaults.shipping_cost;
                this.countryDeliveryTimes[code] = countryData.delivery_time || defaults.delivery_time;
              }
            });
          }
        } catch (error) {
          console.error('Error parsing shipping JSON configuration:', error);
        }
      }

      // Set default values
      this.countryThresholds['default'] = defaults.threshold;
      this.countryShippingCosts['default'] = defaults.shipping_cost;
      this.countryDeliveryTimes['default'] = defaults.delivery_time;
    }

    init() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
          this.updateShippingThreshold();
          this.#bindCountrySelectorListeners();
        });
      } else {
        this.updateShippingThreshold();
        this.#bindCountrySelectorListeners();
      }
    }

    // Returns currently selected country from country selector if present
    getSelectedCountryCode() {
      const input = document.querySelector('.select-popout--country [data-popout-input][name="country_code"]');
      if (input && input.value) {
        return input.value.toUpperCase();
      }
      return null;
    }

    async getUserCountry() {
      try {
        const selectedCode = this.getSelectedCountryCode();
        if (selectedCode) {
          return selectedCode;
        }

        if (window.Shopify && window.Shopify.locale) {
          const locale = window.Shopify.locale;
          const countryCode = locale.split('-')[1] || locale.split('_')[1];
          if (countryCode) {
            return countryCode.toUpperCase();
          }
        }

        const language = navigator.language || navigator.userLanguage;
        const countryCode = language.split('-')[1];
        if (countryCode) {
          return countryCode.toUpperCase();
        }
      } catch (error) {
        return 'default';
      }
    }

    getThresholdForCountry(countryCode) {
      return this.countryThresholds[countryCode] || this.countryThresholds['default'];
    }

    getShippingCostForCountry(countryCode) {
      return this.countryShippingCosts[countryCode] || this.countryShippingCosts['default'];
    }

    getDeliveryTimeForCountry(countryCode) {
      return this.countryDeliveryTimes[countryCode] || this.countryDeliveryTimes['default'];
    }

    getShippingInfoForCountry(countryCode) {
      return {
        country: countryCode,
        freeShippingThreshold: this.getThresholdForCountry(countryCode),
        shippingCost: this.getShippingCostForCountry(countryCode),
        deliveryTime: this.getDeliveryTimeForCountry(countryCode)
      };
    }

    async updateShippingThreshold() {
      const countryCode = await this.getUserCountry();
      const threshold = this.getThresholdForCountry(countryCode);

      this.updateThresholdElements(threshold);
      this.updateCartMessages(threshold);
      window.dynamicShippingThreshold = threshold;
    }

    updateByCountry(countryCode) {
      const code = (countryCode || 'default').toUpperCase();
      const threshold = this.getThresholdForCountry(code);
      this.updateThresholdElements(threshold);
      this.updateCartMessages(threshold);
      window.dynamicShippingThreshold = threshold;
    }

    updateThresholdElements(threshold) {
      const elements = document.querySelectorAll('[data-limit]');
      elements.forEach(element => {
        element.setAttribute('data-limit', threshold);
      });

      const thresholdDisplays = document.querySelectorAll('[data-free-shipping-threshold]');
      thresholdDisplays.forEach(element => {
        element.textContent = `€${threshold}`;
      });
    }

    updateCartMessages(threshold) {
      const cartMessages = document.querySelectorAll('.cart__message');
      const templateMessages = document.querySelectorAll('template .cart__message');
      const allMessages = [...cartMessages, ...templateMessages];

      allMessages.forEach(message => {
        const leftToSpendElement = message.querySelector('[data-left-to-spend]');
        if (leftToSpendElement) {
          let cartTotal = 0;

          if (window.cartTotal) {
            cartTotal = window.cartTotal;
          } else {
            const cartTotalElement = document.querySelector('[data-cart-total]');
            if (cartTotalElement) {
              cartTotal = parseInt(cartTotalElement.getAttribute('data-cart-total')) || 0;
            }
          }

          const cartTotalInEuros = cartTotal / 100;
          const leftToSpend = Math.max(0, threshold - cartTotalInEuros);

          if (leftToSpend > 0) {
            leftToSpendElement.textContent = `€${leftToSpend.toFixed(2)}`;
          } else {
            leftToSpendElement.textContent = '€0.00';
          }
        }
      });

      this.updateProgressBars(threshold);
      this.updateTemplateElements(threshold);
    }

    updateTemplateElements(threshold) {
      const templates = document.querySelectorAll('template[data-cart-drawer-template]');

      templates.forEach(template => {
        const limitElements = template.content.querySelectorAll('[data-limit]');
        limitElements.forEach(element => {
          element.setAttribute('data-limit', threshold);
        });

        const leftToSpendElements = template.content.querySelectorAll('[data-left-to-spend]');
        leftToSpendElements.forEach(element => {
          let cartTotal = 0;
          if (window.cartTotal) {
            cartTotal = window.cartTotal;
          } else {
            const cartTotalElement = document.querySelector('[data-cart-total]');
            if (cartTotalElement) {
              cartTotal = parseInt(cartTotalElement.getAttribute('data-cart-total')) || 0;
            }
          }

          const cartTotalInEuros = cartTotal / 100;
          const leftToSpend = Math.max(0, threshold - cartTotalInEuros);

          element.textContent = `€${leftToSpend.toFixed(2)}`;
        });
      });
    }

    updateProgressBars(threshold) {
      const progressBars = document.querySelectorAll('.cart__message__progress');

      progressBars.forEach(bar => {
        let cartTotal = 0;

        if (window.cartTotal) {
          cartTotal = window.cartTotal;
        } else {
          const cartTotalElement = document.querySelector('[data-cart-total]');
          if (cartTotalElement) {
            cartTotal = parseInt(cartTotalElement.getAttribute('data-cart-total')) || 0;
          }
        }

        const cartTotalInEuros = cartTotal / 100;
        const percent = Math.min(100, (cartTotalInEuros / threshold) * 100);

        bar.style.width = `${percent}%`;
      });
    }

    recalculateOnCartUpdate() {
      if (window.dynamicShippingThreshold) {
        this.updateCartMessages(window.dynamicShippingThreshold);
      }
    }

    // Private: bind listeners to the Shopify country selector
    #bindCountrySelectorListeners() {
      // Click on country option (before form submission)
      document.addEventListener('click', (e) => {
        const option = e.target.closest('.select-popout--country [data-popout-option]');
        if (option) {
          const code = option.getAttribute('data-value');
          if (code) {
            this.updateByCountry(code);
          }
        }
      });

      // Hidden input value change (some themes update it programmatically)
      document.addEventListener('change', (e) => {
        const input = e.target.closest('.select-popout--country [data-popout-input][name="country_code"]');
        if (input && input.value) {
          this.updateByCountry(input.value);
        }
      });
    }
  }

  const dynamicShipping = new DynamicFreeShipping();

  document.addEventListener('cart:updated', () => {
    dynamicShipping.recalculateOnCartUpdate();
  });

  document.addEventListener('cart-drawer:updated', () => {
    dynamicShipping.recalculateOnCartUpdate();
  });

  document.addEventListener('cart:refresh', () => {
    setTimeout(() => dynamicShipping.recalculateOnCartUpdate(), 100);
  });

  document.addEventListener('cart:build', () => {
    setTimeout(() => dynamicShipping.recalculateOnCartUpdate(), 100);
  });

  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-cart-quantity-input]') || e.target.matches('.cart__quantity-input')) {
      setTimeout(() => dynamicShipping.recalculateOnCartUpdate(), 200);
    }
  });

  document.addEventListener('click', (e) => {
    if (e.target.matches('[data-cart-remove]') || e.target.matches('.cart__remove')) {
      setTimeout(() => dynamicShipping.recalculateOnCartUpdate(), 200);
    }
  });

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            if (node.classList && node.classList.contains('cart-drawer')) {
              setTimeout(() => dynamicShipping.recalculateOnCartUpdate(), 100);
            }

            if (node.querySelector && node.querySelector('.cart__message')) {
              setTimeout(() => dynamicShipping.recalculateOnCartUpdate(), 100);
            }
          }
        });
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  window.dynamicShipping = dynamicShipping;

  class CartCountUpdater {
    constructor() {
      this.init();
    }

    init() {
      document.addEventListener('cart:updated', () => {
        this.updateCartCount();
      });

      document.addEventListener('cart-drawer:updated', () => {
        this.updateCartCount();
      });

      document.addEventListener('cart:refresh', () => {
        setTimeout(() => this.updateCartCount(), 100);
      });

      document.addEventListener('cart:build', () => {
        setTimeout(() => this.updateCartCount(), 100);
      });

      document.addEventListener('change', (e) => {
        if (e.target.matches('[data-cart-quantity-input]') || e.target.matches('.cart__quantity-input')) {
          setTimeout(() => this.updateCartCount(), 200);
        }
      });

      document.addEventListener('click', (e) => {
        if (e.target.matches('[data-cart-remove]') || e.target.matches('.cart__remove')) {
          setTimeout(() => this.updateCartCount(), 200);
        }
      });

      document.addEventListener('click', (e) => {
        if (e.target.matches('[data-add-to-cart]') || e.target.closest('[data-add-to-cart]')) {
          setTimeout(() => this.updateCartCount(), 100);
          setTimeout(() => this.updateCartCount(), 500);
          setTimeout(() => this.updateCartCount(), 1000);
        }
      });

      document.addEventListener('submit', (e) => {
        if (e.target.matches('[data-product-form]') || e.target.matches('[data-quickbuy-form]')) {
          setTimeout(() => this.updateCartCount(), 100);
          setTimeout(() => this.updateCartCount(), 500);
          setTimeout(() => this.updateCartCount(), 1000);
        }
      });

      document.addEventListener('cart:updated', () => {
        this.updateCartCount();
      });

      document.addEventListener('click', (e) => {
        if (e.target.matches('[data-cart-drawer-toggle]') || e.target.closest('[data-cart-drawer-toggle]')) {
          setTimeout(() => this.updateCartCount(), 100);
        }
      });

      const cartObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList') {
            const addedNodes = Array.from(mutation.addedNodes);
            const removedNodes = Array.from(mutation.removedNodes);

            const hasCartChanges = addedNodes.some(node => 
              node.nodeType === Node.ELEMENT_NODE && 
              (node.classList?.contains('cart__item') || 
               node.querySelector?.('.cart__item') ||
               node.classList?.contains('cart-drawer'))
            ) || removedNodes.some(node => 
              node.nodeType === Node.ELEMENT_NODE && 
              (node.classList?.contains('cart__item') || 
               node.querySelector?.('.cart__item'))
            );

            if (hasCartChanges) {
              setTimeout(() => this.updateCartCount(), 100);
            }
          }
        });
      });

      cartObserver.observe(document.body, {
        childList: true,
        subtree: true
      });

      this.updateCartCount();
    }

    updateCartCount() {
      let cartCount = 0;

      if (window.cart && window.cart.item_count) {
        cartCount = window.cart.item_count;
      }
      else {
        this.fetchCartFromAPI().then(count => {
          cartCount = count;
          this.updateCartBadges(cartCount);
        }).catch(() => {
          cartCount = this.countCartItems();
          this.updateCartBadges(cartCount);
        });
        return;
      }

      this.updateCartBadges(cartCount);
    }

    async fetchCartFromAPI() {
      try {
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js');
        const cart = await response.json();
        return cart.item_count || 0;
      } catch (error) {
        throw error;
      }
    }

    countCartItems() {
      let totalCount = 0;

      const cartItems = document.querySelectorAll('.cart__item');
      cartItems.forEach(item => {
        const quantityInput = item.querySelector('[data-cart-quantity-input], .cart__quantity-input');
        if (quantityInput) {
          const quantity = parseInt(quantityInput.value) || 0;
          totalCount += quantity;
        }
      });

      if (totalCount === 0) {
        const cartTotalElement = document.querySelector('[data-cart-total]');
        if (cartTotalElement) {
          const cartTotal = parseInt(cartTotalElement.getAttribute('data-cart-total')) || 0;
          if (cartTotal > 0) {
            totalCount = 1;
          }
        }
      }

      if (totalCount === 0) {
        const cartCountElements = document.querySelectorAll('[data-cart-item-count]');
        cartCountElements.forEach(element => {
          const count = parseInt(element.textContent) || 0;
          totalCount += count;
        });
      }

      return totalCount;
    }

    updateCartBadges(count) {
      const badges = document.querySelectorAll('.cart-count-badge');

      badges.forEach(badge => {
        if (badge.closest('.btn--quick') || badge.closest('[data-atc-trigger]')) {
          return;
        }

        const displayCount = count > 99 ? '99+' : count.toString();

        badge.textContent = displayCount;
        badge.setAttribute('aria-label', `${displayCount} items in cart`);
        badge.style.display = 'block';
      });

      const cartCountElements = document.querySelectorAll('[data-cart-count]');
      cartCountElements.forEach(element => {
        if (element.closest('.btn--quick') || element.closest('[data-atc-trigger]')) {
          return;
        }

        const displayCount = count > 99 ? '99+' : count.toString();
        element.textContent = displayCount;
      });
    }
  }

  const cartCountUpdater = new CartCountUpdater();

  window.updateCartCount = function() {
    cartCountUpdater.updateCartCount();
  };

  // Test function to simulate cart count changes
  window.testCartCount = function(count) {
    const badges = document.querySelectorAll('.cart-count-badge');
    badges.forEach(badge => {
      if (badge.closest('.btn--quick') || badge.closest('[data-atc-trigger]')) {
        return;
      }

      const displayCount = count > 99 ? '99+' : count.toString();
      badge.textContent = displayCount;
      badge.setAttribute('aria-label', `${displayCount} items in cart`);

      badge.style.display = 'block';
    });
  };

  window.refreshCartCount = function() {
    cartCountUpdater.fetchCartFromAPI().then(count => {
      cartCountUpdater.updateCartBadges(count);
    }).catch(() => {
      cartCountUpdater.updateCartCount();
    });
  };

  // Octane AI Quiz German Translation
  class OctaneQuizTranslator {
    constructor() {
      this.translations = {
        en: {},
        de: {
          // Page 1/6 - Main skin concerns (Abschnitt 1)
          "What are your main skin concerns?": "Was sind Ihre wichtigsten Hautprobleme?",
          "(Choose up to 3)": "(Wählen Sie bis zu 3)",
          "Dryness or tightness": "Trockenheit oder Spannungsgefühl",
          "Rough or uneven skin texture": "Raue oder unebene Hautstruktur",
          "Dull or tired-looking skin": "Stumpfe oder müde aussehende Haut",
          "Sensitivity or redness": "Empfindlichkeit oder Rötung",
          "Signs of aging (wrinkles, loss of firmness)": "Zeichen der Hautalterung (Falten, Verlust der Festigkeit)",
          "Oily or acne-prone skin": "Fettige oder zu Akne neigende Haut",
          "Sun protection": "Sonnenschutz",

          // Page 2/6 - Skin feel after showering (Abschnitt 1)
          "How does your skin usually feel after showering?": "Wie fühlt sich Ihre Haut normalerweise nach dem Duschen an?",
          "Very dry or tight": "Sehr trocken oder straff",
          "Normal": "Normal",
          "Oily in certain areas": "An bestimmten Stellen ölig",
          "Itchy or irritated": "Juckreiz oder Reizungen",

          // Page 3/6 - Hydration level preference (Abschnitt 2)
          "What level of hydration and texture of body product do you prefer?": "Welche Feuchtigkeitsversorgung und Textur bevorzugen Sie bei Körperpflegeprodukten?",
          "Light and fast-absorbing": "Leicht und schnell einziehend",
          "Deep hydration that lasts": "Tiefenwirksame, lang anhaltende Feuchtigkeitsversorgung",
          "Rich, nourishing texture": "Reichhaltige, pflegende Textur",
          "Not sure": "Nicht sicher",

          // Page 4/6 - When to apply body care (Abschnitt 3)
          "When do you typically apply body care?": "Wann pflegen Sie normalerweise Ihren Körper?",
          "Morning": "Guten Morgen",
          "Night": "Nacht",
          "Both": "Beides",
          "Just after showering": "Gleich nach dem Duschen",
          "Whenever I remember": "Wann immer ich mich erinnere",

          // Page 5/6 - Exfoliation preference (Abschnitt 3)
          "Are you looking for exfoliation or skin renewal?": "Möchten Sie Ihre Haut peelen oder erneuern?",
          "Yes, I want to smooth and brighten my skin": "Ja, ich möchte meine Haut glätten und aufhellen",
          "No, just hydration and comfort": "Nein, nur Feuchtigkeit und Komfort",
          "I'm not sure": "Ich bin mir nicht sicher",

          // Page 6/6 - Signs of aging (Abschnitt 4)
          "Are you noticing signs of skin aging?": "Bemerken Sie Anzeichen von Hautalterung?",
          "Fine lines or crepey skin": "Feine Linien oder faltige Haut",
          "Loss of firmness or elasticity": "Verlust von Festigkeit oder Elastizität",
          "Age spots or discolouration": "Altersflecken oder Verfärbungen",
          "Not really, I want preventive care": "Nicht wirklich, ich möchte Vorsorgeuntersuchungen",
          "Not a concern": "Kein Problem",

          // Loading page - Calculating results
          "Calculating your results...": "Berechne Ihre Ergebnisse...",

          // Final page - Recommended products
          "Your recommended products!": "Ihre empfohlenen Produkte!",
          "Cleanser": "Reinigungsmittel",
          "Lotion or Cream": "Lotion oder Creme",
          "Body Serum": "Body-Serum",
          "Sun Care": "Sonnenschutz",

          // Common elements
          "CONTINUE": "WEITER",
          "ADD TO CART": "IN DEN WARENKORB",
          "Powered by Octane AI": "Unterstützt von Octane AI"
        }
      };

      this.isGermanLocale = this.#detectGermanLocale();
      this.translatedElements = new WeakSet();

      if (this.isGermanLocale) {
        this.init();
      }
    }

    #detectGermanLocale() {
      // Check HTML lang attribute
      const htmlLang = document.documentElement.getAttribute('lang');
      if (htmlLang && (htmlLang.toLowerCase().startsWith('de') || htmlLang === 'de')) {
        return true;
      }

      // Check Shopify locale
      if (window.Shopify && window.Shopify.locale) {
        const locale = window.Shopify.locale.toLowerCase();
        if (locale.startsWith('de')) {
          return true;
        }
      }

      // Check URL path
      const path = window.location.pathname;
      if (path.startsWith('/de') || path.startsWith('/de-')) {
        return true;
      }

      return false;
    }

    init() {
      // Initial translation check
      this.translateQuiz();

      // Watch for dynamically loaded quiz content
      const observer = new MutationObserver(() => {
        this.translateQuiz();
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      // Also check periodically for late-loading content
      let checkCount = 0;
      const maxChecks = 20;
      const interval = setInterval(() => {
        if (checkCount >= maxChecks) {
          clearInterval(interval);
          return;
        }

        this.translateQuiz();
        checkCount++;
      }, 500);
    }

    translateQuiz() {
      const quizWrapper = document.getElementById('octane-quiz-wrapper');
      if (!quizWrapper) {
        return;
      }

      // Translate title
      const titleElement = quizWrapper.querySelector('[data-element="oct-quiz-text oct-quiz-title"]');
      if (titleElement && !this.translatedElements.has(titleElement)) {
        this.#translateElement(titleElement);
        this.translatedElements.add(titleElement);
      }

      // Translate subheading
      const subheadingElement = quizWrapper.querySelector('[data-element="oct-quiz-text oct-quiz-subheading"]');
      if (subheadingElement && !this.translatedElements.has(subheadingElement)) {
        this.#translateElement(subheadingElement);
        this.translatedElements.add(subheadingElement);
      }

      // Translate multiple choice options
      const optionItems = quizWrapper.querySelectorAll('.oct-quiz-multiple-choice-options__option');
      optionItems.forEach(item => {
        // Get all text divs (excluding empty/icon divs)
        const textDivs = Array.from(item.querySelectorAll('div')).filter(div => {
          const text = div.textContent.trim();
          // Only translate divs with meaningful text (at least 2 characters and contains letters)
          return text && text.length >= 2 && /[a-zA-Z]/.test(text);
        });

        textDivs.forEach(div => {
          if (!this.translatedElements.has(div)) {
            this.#translateElement(div);
            this.translatedElements.add(div);
          }
        });
      });

      // Translate continue button
      const continueButton = quizWrapper.querySelector('[data-element="oct-quiz-btn oct-quiz-submit-btn oct-quiz-media"] button');
      if (continueButton && !this.translatedElements.has(continueButton)) {
        this.#translateElement(continueButton);
        this.translatedElements.add(continueButton);
      }

      // Translate product categories on results page (Cleanser, Lotion or Cream, etc.)
      const productCategoryTitles = quizWrapper.querySelectorAll('[data-element="oct-quiz-text oct-quiz-title"][data-content-section="top_content"]');
      productCategoryTitles.forEach(categoryTitle => {
        if (!this.translatedElements.has(categoryTitle)) {
          this.#translateElement(categoryTitle);
          this.translatedElements.add(categoryTitle);
        }
      });

      // Translate "ADD TO CART" buttons on results page
      const allButtons = quizWrapper.querySelectorAll('button');
      allButtons.forEach(button => {
        const buttonText = button.textContent.trim();
        if (buttonText === 'ADD TO CART' && !this.translatedElements.has(button)) {
          button.textContent = 'IN DEN WARENKORB';
          this.translatedElements.add(button);
        }
      });

      // Translate watermark/powered by text
      const poweredByLink = quizWrapper.querySelector('[data-element="oct-quiz-rich-text"][data-content-section="watermark"] a');
      if (poweredByLink && !this.translatedElements.has(poweredByLink)) {
        const originalText = poweredByLink.textContent.trim();
        if (originalText.includes('Powered by Octane AI')) {
          poweredByLink.textContent = originalText.replace('Powered by Octane AI', 'Unterstützt von Octane AI');
          this.translatedElements.add(poweredByLink);
        }
      }

      // Translate "Powered by Octane AI" in bottom_content section
      const bottomContentLinks = quizWrapper.querySelectorAll('[data-element="oct-quiz-rich-text"][data-content-section="bottom_content"] a');
      bottomContentLinks.forEach(link => {
        const linkText = link.textContent.trim();
        if (linkText.includes('Powered by Octane AI') && !this.translatedElements.has(link)) {
          link.innerHTML = link.innerHTML.replace('Powered by Octane AI', 'Unterstützt von Octane AI');
          this.translatedElements.add(link);
        }
      });
    }

    #translateElement(element) {
      if (!element || !element.textContent) {
        return;
      }

      const originalText = element.textContent.trim();

      // Direct match
      if (this.translations.de[originalText]) {
        element.textContent = this.translations.de[originalText];
        return;
      }

      // Handle dynamic text like "What are your main skin concerns? (1/6)"
      // Try to match and translate the main part while preserving numbers/formatting
      for (const [key, value] of Object.entries(this.translations.de)) {
        if (originalText.includes(key)) {
          // Escape special regex characters in the key
          const escapedKey = key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

          // Try to match with key at the start (for titles with page numbers like "(1/6)")
          const matchStart = originalText.match(new RegExp(`^${escapedKey}(.*)$`));
          if (matchStart) {
            const additionalText = matchStart[1] || '';
            element.textContent = value + additionalText;
            return;
          }

          // Try to match with key in the middle or end
          const matchAnywhere = originalText.match(new RegExp(`(.*)${escapedKey}(.*)$`));
          if (matchAnywhere) {
            const prefix = matchAnywhere[1] || '';
            const suffix = matchAnywhere[2] || '';
            element.textContent = prefix + value + suffix;
            return;
          }
        }
      }
    }
  }

  // Initialize translator when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new OctaneQuizTranslator();
    });
  } else {
    new OctaneQuizTranslator();
  }

  // Country selection must submit the country AND the intended language together.
  // Shopify owns market domains, localized paths, translated handles and cookies.
  // Keep the existing DE/AT rule, add CZ, and use the store's English default elsewhere.
  class LocalizationFormHandler {
    constructor() {
      this.languageByCountry = Object.freeze({ DE: 'de', AT: 'de', CZ: 'cs' });
      this.selections = new WeakMap();
      this.bindHandlers();
    }

    bindHandlers() {
      // Capture runs before the theme's option handler calls form.submit().
      // Delegation also covers the mobile header and dynamically rendered forms.
      document.addEventListener('click', (event) => this.handleOptionClick(event), true);
      document.addEventListener('change', (event) => this.handleInputChange(event), true);
      document.addEventListener('submit', (event) => this.handleSubmit(event), true);

      // Native form.submit() does not dispatch submit. Update its serialized data too.
      // Never construct a new FormData here: doing so would dispatch this event again.
      document.addEventListener('formdata', (event) => this.handleFormData(event), true);
    }

    getLocalizationForm(element) {
      if (!(element instanceof Element)) return null;
      const form = element instanceof HTMLFormElement
        ? element
        : element.form || element.closest('form');
      if (!(form instanceof HTMLFormElement)) return null;

      try {
        const action = new URL(form.getAttribute('action') || '', window.location.href);
        return /\/localization\/?$/.test(action.pathname) ? form : null;
      } catch (error) {
        return null;
      }
    }

    normalizeCountry(value) {
      const country = typeof value === 'string' ? value.trim().toUpperCase() : '';
      return /^[A-Z]{2}$/.test(country) ? country : null;
    }

    normalizeLanguage(value) {
      const language = typeof value === 'string'
        ? value.trim().toLowerCase().replace(/_/g, '-')
        : '';
      return /^[a-z]{2,3}(?:-[a-z0-9]{2,8})*$/.test(language) ? language : null;
    }

    getCountryControl(form) {
      return form.querySelector('input[name="country_code"], select[name="country_code"]');
    }

    isCountryForm(form) {
      return Boolean(form.querySelector(
        '.select-popout--country, [data-popout-input][name="country_code"], select[name="country_code"]'
      ));
    }

    setField(form, name, value, createIfMissing = true) {
      const fields = Array.from(form.querySelectorAll(
        `input[name="${name}"], select[name="${name}"]`
      )).filter((field) => !field.matches(':disabled'));

      if (fields.length === 0) {
        if (!createIfMissing) return;
        const field = document.createElement('input');
        field.type = 'hidden';
        field.name = name;
        field.value = value;
        form.appendChild(field);
        return;
      }

      fields.forEach((field) => {
        // A destination market can offer a language absent from the current select.
        if (field instanceof HTMLSelectElement &&
            !Array.from(field.options).some((option) => option.value === value)) {
          const option = new Option(value, value);
          option.hidden = true;
          field.add(option);
        }
        field.value = value;
      });
    }

    prepareLanguage(form, language) {
      this.setField(form, 'language_code', language);
      // Keep legacy theme fields consistent instead of submitting conflicting values.
      this.setField(form, 'locale_code', language, false);

      // Keep the current resource, query (including theme preview) and anchor.
      // Do not prepend /de or /cs: Shopify resolves the destination localization.
      const returnTo = window.location.pathname + window.location.search + window.location.hash;
      this.setField(form, 'return_to', returnTo);
      return returnTo;
    }

    selectCountry(form, value) {
      const country = this.normalizeCountry(value);
      if (!country || !this.getCountryControl(form)) return;

      const language = this.languageByCountry[country] || 'en';
      this.selections.set(form, { type: 'country', country, language });
      this.prepareLanguage(form, language);

      // Prepare fields only. The explicit click handler submits once; other
      // callers, including change events, retain their existing submission flow.
    }

    selectLanguage(form, value) {
      const language = this.normalizeLanguage(value);
      if (!language) return;
      const country = this.normalizeCountry(this.getCountryControl(form)?.value);
      this.selections.set(form, { type: 'language', country, language });
      this.prepareLanguage(form, language);
    }

    handleOptionClick(event) {
      if (!(event.target instanceof Element)) return;
      const option = event.target.closest('[data-popout-option]');
      if (!option) return;
      const form = this.getLocalizationForm(option);
      if (!form) return;

      if (option.closest('.select-popout--country')) {
        const country = this.normalizeCountry(option.getAttribute('data-value'));
        if (!country || !this.getCountryControl(form)) return;

        // Own this explicit click: the theme must not submit the same form again
        // or skip a language change just because the country was already active.
        event.preventDefault();
        event.stopImmediatePropagation();
        this.setField(form, 'country_code', country, false);
        this.selectCountry(form, country);
        HTMLFormElement.prototype.submit.call(form);
        return;
      }

      // An explicit language choice must not be replaced by the country default.
      const popout = option.closest(
        'select-popout, [data-popout], .select-popout, .select-popout--language, .select-popout--locale'
      );
      if (popout?.querySelector('[name="language_code"], [name="locale_code"]')) {
        const language = this.normalizeLanguage(option.getAttribute('data-value'));
        if (!language) return;

        // Submit an explicit language choice without changing the delivery country.
        event.preventDefault();
        event.stopImmediatePropagation();
        this.selectLanguage(form, language);
        HTMLFormElement.prototype.submit.call(form);
      }
    }

    handleInputChange(event) {
      const input = event.target;
      if (!(input instanceof HTMLInputElement || input instanceof HTMLSelectElement)) return;
      const form = this.getLocalizationForm(input);
      if (!form) return;

      if (input.name === 'country_code') {
        this.selectCountry(form, input.value);
      } else if (input.name === 'language_code' || input.name === 'locale_code') {
        this.selectLanguage(form, input.value);
      }
    }

    getSubmissionLanguage(form, country) {
      const selection = this.selections.get(form);
      if (selection?.type === 'language' && selection.country === country) {
        return selection.language;
      }
      if (!country || !this.isCountryForm(form)) return null;
      return this.languageByCountry[country] || 'en';
    }

    handleSubmit(event) {
      const form = this.getLocalizationForm(event.target);
      if (!form) return;
      const country = this.normalizeCountry(this.getCountryControl(form)?.value);
      const language = this.getSubmissionLanguage(form, country);
      if (language) this.prepareLanguage(form, language);
    }

    handleFormData(event) {
      const form = this.getLocalizationForm(event.target);
      if (!form || !event.formData) return;
      const country = this.normalizeCountry(event.formData.get('country_code'));
      const language = this.getSubmissionLanguage(form, country);
      if (!language) return;

      const returnTo = this.prepareLanguage(form, language);
      event.formData.set('language_code', language);
      event.formData.set('return_to', returnTo);
      if (event.formData.has('locale_code')) {
        event.formData.set('locale_code', language);
      }
    }
  }

  new LocalizationFormHandler();

  // Removed the legacy CountryAutoDetector redirects and selector-only updates.
  // The server-rendered Shopify localization is the source of truth on page load.
  // A stale localStorage value or browser timezone must not overwrite that state.
  // Use Shopify's country/language redirection settings for initial localization.

  // Read the server-rendered display policy; never redirect to choose a default.
  function canApplyCollectionMerchandising(grid) {
    if (!grid || !grid.isConnected || !window.location.pathname.includes('/collections/')) {
      return false;
    }

    const section = grid.closest('[data-section-type="collection-template"]');
    if (!section) return false;

    // All Products has an explicit, server-rendered display policy. Other
    // collections keep the previous bundle-placement safety check unchanged.
    const benefitFirst = grid.getAttribute('data-bodiq-order') === 'benefit-first-v1';
    const renderedSort = benefitFirst
      ? grid.getAttribute('data-bodiq-sort')
      : grid.getAttribute('data-collection-rendered-sort');
    if (renderedSort !== 'manual') return false;

    const urlSort = new URLSearchParams(window.location.search).get('sort_by');
    if (urlSort && urlSort !== 'manual') return false;

    const controls = section.querySelectorAll(
      '[data-input-sort]:checked, select[data-input-sort], ' +
      'select[name="sort_by"], input[type="hidden"][name="sort_by"]'
    );
    return !Array.from(controls).some(control => control.value && control.value !== 'manual');
  }

  // One controller handles appended/replaced grids. The initial All Products
  // grouping is already rendered in Liquid, before this JavaScript executes.
  class CollectionMerchandisingHandler {
    constructor() {
      this.sectionSelector = '[data-section-type="collection-template"]';
      this.gridSelector = '[data-collection-products] .grid';
      this.sections = new Map();
      this.gridState = new WeakMap();
      this.pendingSections = new Set();
      this.frame = null;
      this.isCollectionPage = window.location.pathname.includes('/collections/');
      if (!this.isCollectionPage) return;

      this.observer = new MutationObserver(records => {
        records.forEach(record => {
          const target = record.target;
          if (!(target instanceof Element)) return;
          const section = target.closest(this.sectionSelector);
          if (!section) return;

          // Only observe changes to product slots and their server-sort metadata.
          if (target.matches(this.gridSelector) || Array.from(record.addedNodes).some(node =>
            node instanceof Element && (node.matches(this.gridSelector) || node.querySelector(this.gridSelector))
          )) {
            this.schedule(section);
          }
        });
      });

      this.handleChange = event => {
        const input = event.target;
        if (!(input instanceof HTMLInputElement || input instanceof HTMLSelectElement)) return;
        if (!input.matches('[data-input-sort], [name="sort_by"], [name="sort_by_bar"]')) return;
        const section = input.closest(this.sectionSelector);
        if (!section) return;

        // Keep desktop and drawer controls consistent before the theme submits its form.
        // Do not dispatch another change event or send a second request.
        section.querySelectorAll('[data-input-sort]').forEach(control => {
          if (control instanceof HTMLInputElement && control.type === 'radio') {
            control.checked = control.value === input.value;
          } else if (control instanceof HTMLSelectElement &&
              Array.from(control.options).some(option => option.value === input.value)) {
            control.value = input.value;
          }
        });
        section.querySelectorAll('[collection-sort-by]').forEach(control => {
          control.setAttribute('collection-sort-by', input.value);
        });
        this.schedule(section);
      };

      const start = () => {
        document.querySelectorAll(this.sectionSelector).forEach(section => this.register(section));
        document.addEventListener('change', this.handleChange, true);
        window.addEventListener('popstate', () => this.scheduleAll());
        window.addEventListener('pageshow', () => this.scheduleAll());
        document.addEventListener('shopify:section:load', event => {
          const root = event.target;
          if (!(root instanceof Element)) return;
          if (root.matches(this.sectionSelector)) this.register(root);
          root.querySelectorAll(this.sectionSelector).forEach(section => this.register(section));
        });
        document.addEventListener('shopify:section:unload', event => {
          for (const section of this.sections.keys()) {
            if (event.target === section || event.target.contains(section)) this.sections.delete(section);
          }
          this.observeSections();
        });
      };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start, { once: true });
      } else {
        start();
      }
    }

    register(section) {
      if (this.sections.has(section)) return;
      this.sections.set(section, true);
      this.observeSections();
      this.schedule(section);
    }

    observeSections() {
      this.observer.disconnect();
      for (const section of this.sections.keys()) {
        if (!section.isConnected) {
          this.sections.delete(section);
          continue;
        }
        // The section survives replacement of the inner products container.
        this.observer.observe(section, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['data-collection-rendered-sort', 'data-bodiq-sort', 'data-bodiq-order']
        });
      }
    }

    schedule(section) {
      this.pendingSections.add(section);
      if (this.frame !== null) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        const sections = Array.from(this.pendingSections);
        this.pendingSections.clear();
        // Our own moves must not trigger a second merchandising pass.
        this.observer.disconnect();
        try {
          sections.forEach(current => {
            if (!current.isConnected) return;
            current.querySelectorAll(this.gridSelector).forEach(grid => this.apply(grid));
          });
        } finally {
          this.observeSections();
        }
      });
    }

    scheduleAll() {
      this.sections.forEach((_, section) => this.schedule(section));
    }

    apply(grid) {
      if (!canApplyCollectionMerchandising(grid)) {
        this.gridState.delete(grid);
        return;
      }
      const products = Array.from(grid.children).filter(node => node.matches('[data-product-block]'));
      if (products.length === 0) return;

      const previous = this.gridState.get(grid);
      let sourceOrder = products;
      if (previous) {
        const present = new Set(products);
        const retained = previous.source.filter(node => present.has(node));
        const retainedSet = new Set(retained);
        const previousVisible = previous.applied.filter(node => retainedSet.has(node));
        const currentVisible = products.filter(node => retainedSet.has(node));
        // On infinite scroll retain original relative order, then append new server items.
        // If another update reordered existing items, accept that new baseline instead.
        if (currentVisible.every((node, index) => node === previousVisible[index])) {
          sourceOrder = retained.concat(products.filter(node => !retainedSet.has(node)));
        }
      }

      let desired;
      if (grid.getAttribute('data-bodiq-order') === 'benefit-first-v1') {
        // Empty placeholders also have the benefit class. Test the real label,
        // not just whether the class exists, and keep the whole product card.
        const hasBenefit = node => Array.from(node.querySelectorAll(
          '.product-grid-item__benefit:not(.product-grid-item__benefit--placeholder)'
        )).some(label => label.closest('[data-product-block]') === node &&
          label.textContent.replace(/\u00a0/g, ' ').trim().length > 0);
        const withBenefit = sourceOrder.filter(hasBenefit);
        const withoutBenefit = sourceOrder.filter(node => !hasBenefit(node));
        const sunProductId = grid.getAttribute('data-bodiq-sun-product-id');
        const isSun = node => {
          if (node.getAttribute('data-product-merchandising') === 'sun-protection-duo') return true;
          if (sunProductId && (node.getAttribute('data-product-id') === sunProductId ||
              node.id.includes('-' + sunProductId + '--'))) return true;
          return Array.from(node.querySelectorAll('a[href]')).some(link => {
            try {
              const url = new URL(link.getAttribute('href'), window.location.href);
              return /\/products\/sun-protection-duo\/?$/.test(url.pathname);
            } catch (error) {
              return false;
            }
          });
        };
        // Preserve the relative order in each group. The existing special set
        // stays first among unlabelled cards, never inside the labelled group.
        desired = withBenefit.concat(withoutBenefit.filter(isSun), withoutBenefit.filter(node => !isSun(node)));
      } else {
        // Legacy behaviour outside All Products is unchanged.
        const isBundle = node => node.getAttribute('data-product-bundle') === 'true';
        desired = sourceOrder.filter(node => !isBundle(node))
          .concat(sourceOrder.filter(node => isBundle(node)));
        const sunIndex = desired.findIndex(node =>
          node.getAttribute('data-product-merchandising') === 'sun-protection-duo'
        );
        if (sunIndex !== -1) {
          const [sun] = desired.splice(sunIndex, 1);
          const position = desired.length >= 6 ? desired.length - 5 : desired.length;
          desired.splice(position, 0, sun);
        }
      }

      this.gridState.set(grid, { source: sourceOrder, applied: desired });
      if (products.every((node, index) => node === desired[index])) return;

      // Swap only product slots. Promo tiles, shipping-bar nodes and other content stay put.
      const activeElement = document.activeElement;
      const preserveFocus = activeElement instanceof HTMLElement &&
        products.some(node => node.contains(activeElement));
      const slots = products.map(node => {
        const slot = document.createComment('product-slot');
        grid.insertBefore(slot, node);
        return slot;
      });
      slots.forEach((slot, index) => slot.replaceWith(desired[index]));
      if (preserveFocus && activeElement.isConnected && document.activeElement !== activeElement) {
        activeElement.focus({ preventScroll: true });
      }
    }
  }

  new CollectionMerchandisingHandler();

  // Shared: format a price (in Shopify cents) using the current market's currency
  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney && window.theme && window.theme.moneyFormat) {
      return window.Shopify.formatMoney(cents, window.theme.moneyFormat);
    }
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2,
    }).format(cents / 100);
  }

  // Shared: detect market URL prefix (e.g. /de, /cs)
  function getLocalePrefix() {
    var m = window.location.pathname.match(/^\/([a-z]{2})(\/|$)/);
    return m ? '/' + m[1] : '';
  }

  // Shopper Bag: prepend local-currency strikethrough and fix redirect link in all bundle widgets
  (function () {
    const BAG_PRODUCT_ID = 'gid://shopify/Product/16277889876313';
    const BAG_HANDLE = 'shopper-bag';

    function modifyShopperBag() {
      const container = document.getElementById('bundleComponentsContainer');
      if (!container) return false;
      if (container.dataset.shopperBagModified) return true;

      const bagCard = container.querySelector('[data-product-id="' + BAG_PRODUCT_ID + '"]');
      if (!bagCard) return false;

      container.dataset.shopperBagModified = '1';

      // Fix link — prevent navigating away from the current product page
      const link = bagCard.querySelector('.BC_bundle-product-link');
      if (link) {
        link.setAttribute('href', window.location.pathname);
        link.addEventListener('click', function (e) { e.preventDefault(); });
      }

      // Prepend strikethrough price in local market currency
      const priceDiv = bagCard.querySelector('.BC_bundle-product-price');
      if (priceDiv) {
        const oldPrice = document.createElement('span');
        oldPrice.className = 'BC_sale-price BC_old-price';
        oldPrice.textContent = '€13,00'; // shown immediately, replaced by fetch result
        priceDiv.insertBefore(oldPrice, priceDiv.firstChild);

        fetch(getLocalePrefix() + '/products/' + BAG_HANDLE + '.js')
          .then(function (r) { return r.json(); })
          .then(function (product) {
            var price = product.compare_at_price_max || product.compare_at_price_min;
            if (price && price > 0) {
              oldPrice.textContent = formatMoney(price);
            }
          })
          .catch(function () {});
      }

      return true;
    }

    if (!modifyShopperBag()) {
      const observer = new MutationObserver(function (_, obs) {
        if (modifyShopperBag()) obs.disconnect();
      });
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { observer.disconnect(); }, 10000);
    }
  })();

  // Sun Protection Duo — inject second SPF card with 50% off pricing
  (function () {
    if (!window.location.pathname.includes('sun-protection-duo')) return;

    const PLUS_ICON_SVG = '<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.80762 3.25726V11.4239" stroke="#272727" stroke-linecap="round" stroke-linejoin="round"></path><path d="M3.72437 7.34058H11.891" stroke="#272727" stroke-linecap="round" stroke-linejoin="round"></path></svg>';

    function modifyBundleWidget() {
      const container = document.getElementById('bundleComponentsContainer');
      if (!container) return false;

      const products = container.querySelectorAll('.BC_bundle-product');
      if (products.length < 2) return false;

      if (container.dataset.spfModified) return true;
      container.dataset.spfModified = '1';

      const spfCard = products[0];

      // Get handle from existing link before DOM manipulation
      const spfLink = spfCard.querySelector('.BC_bundle-product-link');
      const spfHref = spfLink ? spfLink.getAttribute('href') : '';
      const handleMatch = spfHref.match(/\/products\/([^/?#]+)/);
      const spfHandle = handleMatch ? handleMatch[1] : null;

      // Set EUR fallback prices immediately so nothing is blank
      const firstPriceEl = spfCard.querySelector('.BC_sale-price');
      if (firstPriceEl) firstPriceEl.textContent = '€59,00';

      const firstPlusIcon = container.querySelector('.BC_plus-icon');

      // Clone SPF card for the discounted version
      const discountedCard = spfCard.cloneNode(true);
      const discountedPriceDiv = discountedCard.querySelector('.BC_bundle-product-price');
      if (discountedPriceDiv) {
        discountedPriceDiv.innerHTML =
          '<span class="BC_sale-price BC_old-price">€59,00</span>' +
          '<span class="BC_sale-price BC_very-sale">€47,20</span>';
      }

      // Create second plus icon
      const secondPlusIcon = document.createElement('div');
      secondPlusIcon.className = 'BC_plus-icon';
      secondPlusIcon.innerHTML = PLUS_ICON_SVG;

      // Insert: [SPF full price] [+] [SPF discounted] [+] [Shopper Bag]
      firstPlusIcon.insertAdjacentElement('afterend', secondPlusIcon);
      firstPlusIcon.insertAdjacentElement('afterend', discountedCard);

      // Fetch SPF price in local market currency and update both cards
      if (spfHandle) {
        fetch(getLocalePrefix() + '/products/' + spfHandle + '.js')
          .then(function (r) { return r.json(); })
          .then(function (product) {
            var fullPrice = product.price;
            var discountedPrice = Math.round(fullPrice * 0.8); // 20% off second unit
            if (firstPriceEl) firstPriceEl.textContent = formatMoney(fullPrice);
            if (discountedPriceDiv) {
              discountedPriceDiv.innerHTML =
                '<span class="BC_sale-price BC_old-price">' + formatMoney(fullPrice) + '</span>' +
                '<span class="BC_sale-price BC_very-sale">' + formatMoney(discountedPrice) + '</span>';
            }
          })
          .catch(function () {});
      }

      return true;
    }

    if (!modifyBundleWidget()) {
      const observer = new MutationObserver(function (_, obs) {
        if (modifyBundleWidget()) obs.disconnect();
      });
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(() => observer.disconnect(), 10000);
    }
  })();

  // Redirect "Body Concentrate - Sun Protection" collection to SPF product page
  (function () {
    if (window.location.pathname === '/collections/body-concentrate-sun-protection') {
      window.location.replace('/products/sun-protection-duo');
    }
  })();

  // German collection filter value translations
  (function () {
    if (!window.location.pathname.startsWith('/de')) return;
    if (!window.location.pathname.includes('/collections/')) return;

    const TRANSLATIONS = {
      'Sunscreen': 'Sonnenschutz',
      'Sun Protection': 'Sonnenschutz',
    };

    function translateFilterValues() {
      const walker = document.createTreeWalker(
        document.body,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode: function (node) {
            return TRANSLATIONS[node.textContent.trim()]
              ? NodeFilter.FILTER_ACCEPT
              : NodeFilter.FILTER_SKIP;
          }
        }
      );
      var nodes = [];
      var n;
      while ((n = walker.nextNode())) nodes.push(n);
      nodes.forEach(function (node) {
        node.textContent = TRANSLATIONS[node.textContent.trim()];
      });
    }

    translateFilterValues();

    var debounce;
    var obs = new MutationObserver(function () {
      clearTimeout(debounce);
      debounce = setTimeout(translateFilterValues, 150);
    });
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 20000);
  })();

})();